import React from 'react';
import ForgotPasswordSection from '../Components/ForgotPassword';

const ForgotPasswordPage = () => (
  <ForgotPasswordSection />
);

export default ForgotPasswordPage;
